

/**
 * Case listed here are sorted client-side**.

 * - EnergyBalance
 * - SubscriptionStatus
 * - SubscriptionEndDate
 * - MeterStatus
 
 * All other Cases are sorted on the  server-side via API call.
 */

import { CustomerListingResponseItem } from  '../models/customer.model';

export function sortCustomers(
  data: CustomerListingResponseItem[],
  field: string,
  direction: 'asc' | 'desc'
): CustomerListingResponseItem[] {

  const sorted = [...data];

  return sorted.sort((a, b) => {
    switch (field) {
      case 'EnergyBalance': {
        const valA = a.EnergyBalance ?? 0;
        const valB = b.EnergyBalance ?? 0;
        return direction === 'asc' ? valA - valB : valB - valA;
      }

      case 'SubscriptionEndDate': {
        const dateA = a.SubEndDate ? new Date(a.SubEndDate).getTime() : 0;
        const dateB = b.SubEndDate ? new Date(b.SubEndDate).getTime() : 0;
        return direction === 'asc' ? dateA - dateB : dateB - dateA;
      }

      case 'SubscriptionStatus': {
        const now = new Date();
        const statusA =
          a.SubEndDate && new Date(a.SubEndDate) > now ? 'Active' : 'Inactive';
        const statusB =
          b.SubEndDate && new Date(b.SubEndDate) > now ? 'Active' : 'Inactive';
        return direction === 'asc'
          ? statusA.localeCompare(statusB)
          : statusB.localeCompare(statusA);
      }

      case 'MeterStatus': {
        const valA = a.MeterStatus ?? '';
        const valB = b.MeterStatus ?? '';
        return direction === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      default:
        return 0;
    }
  });
}

